import request from '@/utils/request'

export function register (params) {
  return request({
    method: 'get',
    params: {
      r: 'reg/account',
      ...params
    }
  })
}

//  一键注册
export function getRegisterAccount (params) {
  return request({
    method: 'get',
    params: {
      r: 'reg/generate-account',
      params
    }
  })
}

// 修改密码
export function updatePassword (params) {
  return request({
    method: 'get',
    params: {
      r: 'user/modify-pwd',
      ...params
    }
  })
}

// 绑定手机
export function bindPhone (params) {
  return request({
    method: 'get',
    params: {
      r: 'user/bind-phone',
      ...params
    }
  })
}

// 重置密码
export function resetPassword (params) {
  return request({
    method: 'get',
    params: {
      r: 'reg/reset-password',
      ...params
    }
  })
}
